'use strict';

var _ = require('lodash');
var FaresOptimizerWebFareChartController = function FaresOptimizerWebFareChartController($scope, $filter, webFareChartTransformationService, chartFormatter, FaresOptimizerConstants, faresOptimizerFareTooltipService) {
  $scope.selectedLowestWebFare = FaresOptimizerConstants.WEB_FARE_LOWEST_TOTAL_KEY;
  $scope.chartFormatters = {
    xAxisTickValues: function xAxisTickValues(records) {
      var tickValues = [],
        totalRecords = records.length,
        i = 0,
        numberOfTicks = webFareChartTransformationService.getMinimumLengthOfRecord();
      numberOfTicks = totalRecords < numberOfTicks ? totalRecords : numberOfTicks;
      var ticksInterval = Math.ceil(totalRecords / numberOfTicks);
      while (i % ticksInterval === 0 && i < totalRecords) {
        tickValues.push(records[i].departureDate);
        i = i + ticksInterval;
      }
      return tickValues;
    },
    yAxisTickFormatter: chartFormatter.humanReadable,
    tooltipFormatter: function tooltipFormatter(tooltipData) {
      return faresOptimizerFareTooltipService.getWebFareTooltipContent(tooltipData);
    }
  };

  // handle toggle between total and base fare
  $scope.$on('chart.webfare.toggle.faretype.data', function (evt, webFareData) {
    $scope.selectedLowestWebFare = webFareData.type;
    reDrawWebFareChart(webFareData);
  });
  $scope.$watchCollection('webFareChartData', function (chartData) {
    if (chartData) {
      $scope.transformedData = !_.isEmpty(chartData) ? webFareChartTransformationService.transformWebFareData($scope.chartDataTitle, chartData, $scope.selectedLowestWebFare) : chartData;
      $scope.transformedData = _.sortBy($scope.transformedData, function (data) {
        return new Date(data.dateToSort).getTime();
      });
      displayWebFareChart();
    }
  });
  function reDrawWebFareChart(webFareData) {
    $scope.transformedData = _.map($scope.transformedData, function (data) {
      if (data.title === webFareData.webFareData.title) {
        data.fareToPlot = webFareChartTransformationService.checkWhichFareToPlot(webFareData.type, data);
        data.lowestFareOccurence = webFareChartTransformationService.checkWhichFareOccurenceToPlot(webFareData.type, data);
      }
      return data;
    });
    displayWebFareChart();
  }
  function displayWebFareChart() {
    $scope.renderChart($scope.transformedData, $scope.chartFormatters);
  }
};
FaresOptimizerWebFareChartController.$inject = ['$scope', '$filter', 'FaresOptimizerWebFareChartTransformationService', 'FormatterService', 'FaresOptimizerConstants', 'FaresOptimizerFareTooltipService'];
module.exports = FaresOptimizerWebFareChartController;